import cartItem from "../components/cartItem";
import cartView from "../views/cartView";
import { updateProductsQuantityInCart } from "./productDetailsViewLogic";
import pesos from "../helpers/pesosCurrency";
import displayInfoContainer from "../components/infoContainer";
export function cartViewLogic(store, mainContent) {
    viewRendering(mainContent, store);
    addCartProducts(store);
    removeCartProduct(store, mainContent);
    changeProductAmount(store, mainContent);
    cleanCartButtonEvent(store, mainContent);
}
//view rendering
function viewRendering(mainContent, store) {
    mainContent.innerHTML = cartView(store);
}
//Add cart products to the cart view table
function addCartProducts(store) {
    var cart = store.cart.showAll();
    fillCartViewTable(cart);
}
//load cart products in cart view table
function fillCartViewTable(cart) {
    var cartTable = document.getElementById("cart-table");
    if (cart.length != 0) {
        cart.forEach(function (item) {
            cartTable.innerHTML += cartItem(item);
        });
    }
}
//remove a cart item
function removeCartProduct(store, mainContent) {
    var removeButtons = document.querySelectorAll(".js-remove");
    removeButtons.forEach(function (removeButton) {
        removeButton.addEventListener("click", function () {
            if (this.dataset.productId) {
                store.cart.remove(this.dataset.productId);
                removeRow(this.dataset.productId);
                updateProductsQuantityInCart(store);
            }
            if (store.cart.showAll().length == 0) {
                viewRendering(mainContent, store);
            }
        });
    });
}
//add or substract the product quantity
function changeProductAmount(store, mainContent) {
    substractProductAmountEvent(store, mainContent);
    addProductAmountEvent(store);
}
function substractProductAmountEvent(store, mainContent) {
    var substractButtons = document.querySelectorAll(".js-substract");
    substractButtons.forEach(function (substractButton) {
        substractButton.addEventListener("click", function () {
            if (this.dataset.productId) {
                var product = store.getProductById(this.dataset.productId);
                store.cart.substract(this.dataset.productId);
                updateProductsQuantityInCart(store);
                if (store.cart.showAll().length == 0) {
                    viewRendering(mainContent, store);
                }
                else {
                    refreshAmount(store, product);
                }
            }
        });
    });
}
function addProductAmountEvent(store) {
    var addButtons = document.querySelectorAll(".js-add");
    addButtons.forEach(function (addButton) {
        addButton.addEventListener("click", function () {
            if (this.dataset.productId) {
                var product = store.getProductById(this.dataset.productId);
                var cartItem_1 = store.cart.getCartItemById(this.dataset.productId);
                if (cartItem_1.amount < product.stock) {
                    store.cart.add(product);
                    updateProductsQuantityInCart(store);
                    refreshAmount(store, product);
                }
                else {
                    displayInfoContainer("No es posible adquirir mas de " + cartItem_1.amount + " unidades de \u00E9ste producto - Stock insuficiente.");
                }
            }
        });
    });
}
function refreshAmount(store, product) {
    var itemAmount = document.getElementById("amount" + product.id);
    var itemTotalPrice = document.getElementById("totalPrice" + product.id);
    var finalPrice = document.getElementById("final-price");
    if (itemAmount && itemTotalPrice && finalPrice) {
        var cartItem_2 = store.cart.getCartItemById("" + product.id);
        if (cartItem_2) {
            itemAmount.innerHTML = cartItem_2.amount.toString();
            itemTotalPrice.innerHTML = pesos.format(cartItem_2.amount * cartItem_2.item.getPriceWithDiscount());
        }
        else {
            removeRow(product.id);
        }
        finalPrice.innerHTML = calculateFinalPrice(store);
    }
}
function removeRow(id) {
    var row = document.getElementById("row" + id);
    if (row) {
        row.remove();
    }
}
function calculateFinalPrice(store) {
    return pesos.format(store.cart
        .showAll()
        .map(function (previousValue) {
        return previousValue.amount * previousValue.item.getPriceWithDiscount();
    })
        .reduce(function (a, b) { return a + b; }));
}
// Remove products from cart button event
function cleanCartButtonEvent(store, mainContent) {
    var cleanCartBtn = document.getElementById("clean-cart-btn");
    if (cleanCartBtn) {
        cleanCartBtn.addEventListener("click", function () {
            store.cart.clearAll();
            viewRendering(mainContent, store);
            updateProductsQuantityInCart(store);
        });
    }
}
